// ----------- ACTION NAMES

const MEDIA_BROWSER_FETCH_LIST = 'MEDIA_BROWSER_FETCH_LIST';
const MEDIA_BROWSER_FETCH_LIST_ERROR = 'MEDIA_BROWSER_FETCH_LIST_ERROR';
const MEDIA_BROWSER_FETCH_LIST_LOADING = 'MEDIA_BROWSER_FETCH_LIST_LOADING';
const MEDIA_BROWSER_FETCH_LIST_SUCCESS = 'MEDIA_BROWSER_FETCH_LIST_SUCCESS';

const MEDIA_BROWSER_FETCH_ITEM = 'MEDIA_BROWSER_FETCH_ITEM';
const MEDIA_BROWSER_FETCH_ITEM_ERROR = 'MEDIA_BROWSER_FETCH_ITEM_ERROR';
const MEDIA_BROWSER_FETCH_ITEM_LOADING = 'MEDIA_BROWSER_FETCH_ITEM_LOADING';
const MEDIA_BROWSER_FETCH_ITEM_SUCCESS = 'MEDIA_BROWSER_FETCH_ITEM_SUCCESS';


export {
  MEDIA_BROWSER_FETCH_LIST,
  MEDIA_BROWSER_FETCH_LIST_ERROR,
  MEDIA_BROWSER_FETCH_LIST_LOADING,
  MEDIA_BROWSER_FETCH_LIST_SUCCESS,

  MEDIA_BROWSER_FETCH_ITEM,
  MEDIA_BROWSER_FETCH_ITEM_ERROR,
  MEDIA_BROWSER_FETCH_ITEM_LOADING,
  MEDIA_BROWSER_FETCH_ITEM_SUCCESS,
};
